import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Stack, Text, Fabric, Image, PrimaryButton } from 'office-ui-fabric-react';
import GainUniqueInsightsIcon from '../../assets/gain-unique-insights.svg';
import SimplerAuditingIcon from '../../assets/simpler-auditing.svg';
import SmartContractsIcon from '../../assets/smart-contracts.svg';
import TransactionDetailsIcon from '../../assets/transaction-details.svg';
import styles from './Marketing.style';
import { isMobileApp } from '../../utils';

const isMobile = isMobileApp();

const Marketing = ({ login }) => (
  <Fabric className={clsx(styles.root, isMobile && styles.mobile)}>
    <Stack className={styles.hero}>
      <Stack align="start" className={styles.heroHeader} data-testid="header">
        <Text block>Royalties Calculation and Experience</Text>
      </Stack>

      <Text align="start" className={styles.heroDetails}>
        This platform provides end to end experience of calculating and paying out Royalties for
        digital assets in a distributed and decentralized manner. It provides near real-time
        visibility into contract operations and transaction details.
      </Text>

      <PrimaryButton
        data-testid="login-button"
        onClick={login}
        text="Login"
        className={styles.loginButton}
      />
    </Stack>

    <Stack className={styles.aboutRoyalties}>
      <Text className={styles.aboutRoyaltiesHeadline}>Platform Capabilities</Text>

      <Stack horizontal horizontalAlign="space-around" wrap="flow">
        <Stack className={styles.card}>
          <Stack.Item align="center" className={styles.cardItem}>
            <Image
              width={150}
              height={250}
              src={TransactionDetailsIcon}
              alt="Transaction Details"
            />
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardHeading}>Transaction Details</Text>
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardText}>
              View in near real-time transaction details to perform royalty accruals on a more
              frequent basis.
            </Text>
          </Stack.Item>
        </Stack>
        <Stack className={styles.card}>
          <Stack.Item align="center" className={styles.cardItem}>
            <Image width={150} height={250} src={SmartContractsIcon} alt="Smart Contracts" />
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardHeading}>Smart Contracts</Text>
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardText}>
              Review and reach consensus on contract terms, digitize as smart contracts.
            </Text>
          </Stack.Item>
        </Stack>
        <Stack className={styles.card}>
          <Stack.Item align="center" className={styles.cardItem}>
            <Image
              width={150}
              height={250}
              src={GainUniqueInsightsIcon}
              alt="Gain Unique Insights"
            />
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardHeading}>Gain Unique Insights</Text>
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardText}>
              Gain business insight from underlying royalty transaction detail.
            </Text>
          </Stack.Item>
        </Stack>
        <Stack className={styles.card}>
          <Stack.Item align="center" className={styles.cardItem}>
            <Image width={150} height={250} src={SimplerAuditingIcon} alt="Simpler Auditing" />
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardHeading}>Simpler Auditing</Text>
          </Stack.Item>
          <Stack.Item align="center" className={styles.cardItem}>
            <Text className={styles.cardText}>
              Significantly reduce the effort involved in auditing, accruing, and reconciling.
            </Text>
          </Stack.Item>
        </Stack>
      </Stack>
    </Stack>

    <Stack>
      <Stack.Item align="center" className={styles.buttonMargin}>
        <PrimaryButton
          data-testid="contact-button"
          href="mailto:roybcdevteam@microsoft.com"
          text="Contact us Now"
          className={styles.contactButton}
        />
      </Stack.Item>
      <Stack.Item align="center">
        <Text variant="large">
          Already have an account? &nbsp;
          <a href="/login" onClick={login} className={styles.loginText}>
            Login
          </a>
        </Text>
      </Stack.Item>
    </Stack>

    {!isMobile && (
      <>
        <Stack
          horizontal
          horizontalAlign="space-around"
          className={styles.navFooter}
          data-testid="navFooter"
        >
          <Stack.Item>
            <Text>English (United States)</Text>
          </Stack.Item>
          <Stack.Item>
            <a href="mailto:roybcdevteam@microsoft.com">Contact us</a>
          </Stack.Item>
          <Stack.Item>
            <a href=" http://go.microsoft.com/fwlink/?LinkId=521839">Microsoft Privacy Statement</a>
          </Stack.Item>
          <Stack.Item>
            <a href="https://www.microsoft.com/en-us/legal/intellectualproperty/copyright/default.aspx">
              Terms of use
            </a>
          </Stack.Item>
          <Stack.Item>
            <a href="https://www.microsoft.com/en-us/legal/intellectualproperty/trademarks/en-us.aspx">
              Trademarks
            </a>
          </Stack.Item>
          <Stack.Item>
            <Text>Version ({window.config.buildVersion})</Text>
          </Stack.Item>
        </Stack>
      </>
    )}
  </Fabric>
);

Marketing.propTypes = {
  login: PropTypes.func.isRequired,
};

export default Marketing;
